import { useCallback, useEffect, useState } from 'react';
import { draftKey, emptyDraft, loadLocalDraft, mailError, saveLocalDraft } from '../mailboxModel';

export function useLocalDraft(key, { profile, canSend, notify }) {
  const [draft, setDraft] = useState(null);
  const [storageError, setStorageError] = useState('');
  const loadDraft = useCallback((userId, email) => {
    try { setDraft(loadLocalDraft(draftKey(userId, email))); } catch (failure) { setStorageError(mailError(failure)); }
  }, []);
  useEffect(() => {
    if (!key || !draft) return;
    try { saveLocalDraft(key, draft); setStorageError(''); } catch (_) { setStorageError('This draft could not be saved on this browser. Keep this window open and free browser storage before sending.'); }
  }, [key, draft]);
  useEffect(() => {
    if (!key) return undefined;
    const changed = event => {
      if (event.key !== key) return;
      try { setDraft(loadLocalDraft(key)); } catch (_) { setStorageError('The draft changed in another tab and could not be loaded.'); }
    };
    const warn = event => { if (storageError) { event.preventDefault(); event.returnValue = ''; } };
    window.addEventListener('beforeunload', warn);
    window.addEventListener('storage', changed);
    return () => { window.removeEventListener('beforeunload', warn); window.removeEventListener('storage', changed); };
  }, [key, storageError]);
  const compose = seed => {
    if (!profile || !canSend) return;
    if (draft) { setDraft(current => ({ ...current, closed: false, minimized: false })); notify.info('Your current draft is open. Send or discard it before starting another.'); return; }
    setDraft({ ...emptyDraft(), ...seed, delivery_key: crypto.randomUUID() });
  };
  const clearDraft = () => {
    try { localStorage.removeItem(key); setDraft(null); setStorageError(''); return true; }
    catch (_) { setStorageError('Unable to clear the saved draft. Please free browser storage.'); return false; }
  };
  const persistCommand = next => { saveLocalDraft(key, next); setDraft(next); };
  return { draft, setDraft, storageError, loadDraft, compose, clearDraft, persistCommand };
}
